import WidgetEditDialog from './widgetEditDialog.vue';
import Chart from './chart/chart.vue';
import TwinTable from './twinTable/twinTable.vue';
import TwinMap from './twinMap/twinMap.vue';
import { mapState } from 'vuex';
import twinFields from './twinFields';
import { get } from 'lodash';
import { createNestedDashboardParameters } from '@/utils/dashboard-utils';
import { VCardText } from 'vuetify/lib';
const {
  evaluateTemplate
} = twinFields;
export default {
  name: 'WidgetCard',
  components: {
    WidgetEditDialog,
    Chart,
    TwinTable,
    TwinMap,
    VCardText
  },
  props: {
    dashboardId: {
      type: String,
      required: true
    },
    widget: {
      type: Object,
      required: true
    },
    dataSet: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false
    },
    customParameters: {
      type: Object,
      required: true
    },
    dateRange: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    displayAsJson: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isDeleting: false,
      showEditWidgetDialog: false,
      manuallyRefreshingData: false,
      hidden: false
    };
  },
  computed: {
    ...mapState('app', ['color']),
    ...mapState('dashboards', ['widgetData', 'dashboards']),
    someStatesLimitReached() {
      if (!this.dataSet.data) {
        return false;
      }
      return Object.values(get(this.dataSet, 'data', {})).some(chartTypeData => {
        if (!chartTypeData) {
          return false;
        }
        return chartTypeData.some(item => get(item, 'states', []).some(state => state.limitReached));
      });
    },
    showHeader() {
      if (this.editMode) {
        return true;
      }
      return !this.widget.hideHeader;
    },
    floatHeader() {
      if (this.editMode && this.widget.hideHeader) {
        return true;
      }
      return this.widget.floatHeader;
    },
    mapPaddingTop() {
      if (!this.showHeader) {
        return 50;
      }
      if (this.floatHeader) {
        return 100;
      }
      return 50;
    },
    cardTitle() {
      const titleTemplate = get(this.widget, 'title', '');
      if (this.dataSet.error) {
        return titleTemplate;
      }
      const datasetData = get(this, 'dataSet.data', {});
      const twins = Object.values(datasetData).map(chartTypeDataArray => chartTypeDataArray.map(data => data)).flat().filter(Boolean);
      const title = evaluateTemplate({
        i18n_t: this.$t,
        twin: twins,
        template: titleTemplate,
        customParameters: this.customParameters
      });
      return title;
    }
  },
  watch: {
    'widget.minHeightPx': function () {
      this.hidden = true;
      this.$nextTick(() => {
        this.hidden = false;
      });
    }
  },
  methods: {
    async changeWidgetSize(size) {
      const {
        success,
        errror
      } = await this.$store.dispatch('dashboards/changeWidgetConfig', {
        dashboardId: this.dashboardId,
        widgetId: this.widget.id,
        config: {
          size
        }
      });
      if (!success) {
        console.error(errror);
        this.$snack(this.$t('Dashboards.components.widgetCard.snack.error.couldNotUpdateWidgetSize', {
          error: errror.message
        }), 'error');
      }
    },
    async removeWidget() {
      this.isDeleting = true;
      const {
        success,
        error
      } = await this.$store.dispatch('dashboards/removeWidget', {
        dashboardId: this.dashboardId,
        widgetId: this.widget.id
      });
      this.isDeleting = false;
      if (!success) {
        console.error(error);
        this.$snack(this.$t('Dashboards.components.widgetCard.snack.error.couldNotRemoveWidget', {
          error: get(error, 'message', String(error))
        }), 'error');
        return;
      }
    },
    openUrl(url, target) {
      if (url.startsWith('/')) {
        if (target === '_self') {
          this.$router.push(url);
          return;
        }
        if (!url.startsWith('/#/')) {
          url = `/#${url}`;
        }
      }
      window.open(url, target);
    },
    async onActionClick({
      action,
      twin
    }) {
      if (this.editMode || this.isPreview !== false) {
        this.$snack(this.$t('Dashboards.components.widgetCard.snack.info.actionPreventedInEditMode'), 'info');
        return;
      }
      switch (action.action) {
        case 'url.open':
          {
            const target = action.parameters.openInNewTab ? '_blank' : '_self';
            let url = action.parameters.url;
            if (twin) {
              url = evaluateTemplate({
                i18n_t: this.$t,
                twin,
                template: url,
                customParameters: this.customParameters
              });
            }
            this.openUrl(url, target);
            break;
          }
        case 'twin.open':
          {
            const target = action.parameters.openInNewTab ? '_blank' : '_self';
            let twinId;
            if (action.parameters.useOpenedTwin) {
              twinId = twin.id;
            } else {
              twinId = action.parameters.twinId;
            }
            this.openUrl(`/digitaltwin-mgmt?active=${twinId}`, target);
            break;
          }
        case 'dashboard.open':
          {
            const {
              dashboardId,
              navigationType,
              parameters
            } = action.parameters.nestedDashboard;
            const nestedDashboard = this.dashboards.find(dashboard => dashboard.id === dashboardId);
            if (!nestedDashboard) {
              console.error(`Nested dashboard with id ${dashboardId} not found`);
              this.$snack(this.$t('Dashboards.components.twinTable.error.nestedDashboardNotFound'), 'error');
              return;
            }
            const nestedDashboardParameters = createNestedDashboardParameters(nestedDashboard, parameters, this.customParameters, twin);
            this.$emit('activate-sub-dashboard', {
              dashboardId,
              navigationType,
              customParameters: nestedDashboardParameters
            });
            break;
          }
        default:
          console.warn('Unknown action', action);
          this.$snack(this.$t('Dashboards.components.widgetCard.snack.error.unknownAction', {
            action: action.action
          }), 'error');
          break;
      }
    }
  }
};